import { render, staticRenderFns } from "./ProductColumnList.vue?vue&type=template&id=55cf60ea&scoped=true"
import script from "./ProductColumnList.vue?vue&type=script&lang=js"
export * from "./ProductColumnList.vue?vue&type=script&lang=js"
import style0 from "./ProductColumnList.vue?vue&type=style&index=0&id=55cf60ea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cf60ea",
  null
  
)

export default component.exports